import * as React from "react";
import Component from "../../AbstractComponent";

import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';

class NoteUpdate extends Component {

  public state = {
    note: "",
    error: ""
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount(): any {
    this.setState({
      note: this.props.event.reason
    });
  }

  public edit = (): void => {
    if (this.state.note.length === 0 || this.state.note.trim() == '') {
      this.setState({
        error: this.trans("please-enter-a-note")
      });
      return;
    }

    this.props.onUpdate.call(this, this.props.event, this.state.note, null);
  }

  public cancel = () => {
    this.props.onCancel.call(this);
  }

  public render() {
    return (
      <div className="note-form-container">
        <TextField
          autoComplete="off"
          className="form-element full-size"
          multiline={true}
          type="text"
          rowsMax={10}
          value={this.state.note}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
          autoFocus={true}
          variant="standard"
          error={!!this.state.error}
        />
        {!!this.state.error && <div className="component-error-text">{this.state.error}</div>}
        <div className="buttons task-buttons" style={{width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "10px"}}>
          <Button
            color="primary"
            onClick={e => {
              e.stopPropagation();
              this.setState({
                note: "",
                error: "",
              }, this.cancel)}}
            className={"full-size"}
            style={{marginRight: "10px"}}
          >
            {this.trans("button-cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={e => {
                e.stopPropagation();
                this.edit();
              }
            }
            className={"full-size"}
          >
            {this.trans("button-save")}
          </Button>
        </div>
      </div>
    );
  }
}

export { NoteUpdate };
